import {get , post} from './index.js'

export const headers = {customerId: ''};

// 获取用户信息
export const getUserInfo = (params) => get('/xb-api/wx-user/info', params, {showLoad: true});

// 获取企业公众号信息appid
export const getAppid = (params) => get('/xb-api/xb-api/customer-official-account-info', params);

// 获取微信OpenId
export const getWxOpenid = (params) => get('/xb-api/wx-user/wx-user-open-id', params)

// 获取用户手机号绑定状态
export const getCodeStatus = (params) => get('/xb-api/wx-user/phone-bind-status', params);

// 获取订单数信息
export const getOrderNum = (params) => post('/user-api/bill/query-bill-info', params, {headers: headers});

// 获取销售单分页
export const pageSaleBill = (params) => post('/user-api/bill/page-sale-bill', params, {headers: headers, showLoad: true});

// 获取收款单分页
export const pageReceiptBill = (params) => post('/user-api/bill/page-receipt-bill', params, {headers: headers, showLoad: true});

// 获取换货单分页
export const pageGoodsChangeBill = (params) => post('/user-api/bill/page-goods-change-bill', params, {headers: headers, showLoad: true});

// 获取退货单分页
export const pageGoodsReturnBill = (params) => post('/user-api/bill/page-sale-return-bill', params, {headers: headers, showLoad: true});

// 获取调账单分页
export const pageChangeReceivableBill = (params) => post('/user-api/bill/page-change-receivable-bill', params, {headers: headers, showLoad: true});

// 获取组合单分页
export const pageCombineBill = (params) => post('/user-api/bill/page-sale-combine-bill', params, {headers: headers, showLoad: true});